import { TicketAccess } from "./TicketAccess";

export interface BasketItem {
  facilityIds: string; //ustawiam id'ki obiektu
  facilityName: string;
  facilityStreet: string;
  facilityLocality: string;
  pictureUrl: string;
  description: string;
  assortIds: string; //ustawiam id'ki asortymentu
  assortName: string;
  qnt: number; //ustawiam qnt
  price: number;
  listPrice: number;
  minSale: number;
  maxSale: number;
  validFrom: string;
  validTo: string;
  promotions: [];
  ticketAccess: TicketAccess[]; //ustawiam liste imprez
  ticket: boolean;
  pass: boolean;
  service: boolean;
  accountIncome: boolean;
}

export const setBasketItemLimited = (
  facilityIds: string,
  assortIds: string,
  validFrom: string | null,
  qnt: number | 1,
  ticketAccess: TicketAccess[] | any
): BasketItem => {
  return {
    facilityName: "",
    facilityStreet: "",
    facilityLocality: "",
    pictureUrl: "",
    description: "",
    assortName: "",
    price: 0,
    promotions: [],
    validFrom: validFrom,
    facilityIds: `0,${facilityIds}`,
    assortIds,
    qnt: qnt,
    ticketAccess,
  } as BasketItem;
};
export const setBasketItemExercise = (
  facilityIds: string,
  assort: string,
  price: number,
  ticketAccess: TicketAccess | any,
  validFrom: string | null,
  qnt: number | 1
): BasketItem => {
  return {
    facilityIds,
    assortIds: assort,
    ticketAccess,
    qnt: qnt,
    validFrom,
    price: price,
  } as BasketItem;
};
